import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LoginCredentials, UserProfile } from '@models';
import { Store } from '@ngrx/store';

import { authActions, authSelectors } from '@store';
import { filterEmpty } from '@utils';

@Injectable()
export class AuthService {
  constructor(private _store: Store) {
    this.user$ = _store.select(authSelectors.selectUserProfile).pipe(filterEmpty());
    this.error$ = _store.select(authSelectors.selectHasError);
    this.isAuthenticated$ = _store.select(authSelectors.selectIsAuthenticated);
    this.accessToken$ = _store.select(authSelectors.selectAccessToken);
    this.clientId$ = _store.select(authSelectors.selectClientId);
  }

  public error$: Observable<boolean>;
  public user$: Observable<UserProfile>;
  public isAuthenticated$: Observable<boolean>;
  public accessToken$: Observable<string>;
  public clientId$: Observable<string>;

  login(credentials: LoginCredentials): void {
    this._store.dispatch(authActions.login({ credentials }));
  }

  initialize(): void {
    this._store.dispatch(authActions.initialize());
  }

  signUp(value: any): void {}

  signInUsingToken(): void {}

  logout(): void {
    this._store.dispatch(authActions.logout());
  }

  check(): Observable<boolean> {
    return this._store.select(authSelectors.selectIsAuthenticated);
  }
}
